export default __webpack_public_path__ + "static/media/check_circle_inverse.668002a9.svg";